/**
 * App ui configurations
 */
const appConfig = {
  /**
   * Api response status names
   */
  responseStatus: {
    success: "success",
    error: "error",
  },
  /** Tooltip */
  tooltip: {
    type: {
      default: "default",
      dark: "dark",
    },
    colors: {
      default: "",
      dark: "rgba(0, 0, 0, 0.87)",
    },
  },
  // Snackbar configuration
  snackbar: {
    timeout: 10000,
    config: {
      success: {
        icon: "mdi-check-circle-outline",
        bgColor: "#BCECC8",
        iconColor: "#29993E",
      },
      error: {
        icon: "mdi-information-outline",
        bgColor: "rgba(239, 197, 202, 1)",
        iconColor: "#B00020",
      },
      info: {
        icon: "mdi-information-outline",
        bgColor: "#f7d36f",
        iconColor: "#ffffff",
      },
      close: {
        icon: "mdi-close",
        bgColor: "inherit",
        iconColor: "rgba(0, 0, 0, 0.6)",
      },
    },
    // Types of the snackbar
    snackbarTypes: {
      success: "success",
      error: "error",
      info: "info",
    },
  },

  /**
   * Loader
   */
  loader: {
    color: "primary",
    size: 70,
    small: 40,
  },
  // Application layouts
  layouts: {
    app: "App",
    auth: "Auth",
  },
  // Alert
  alert: {
    colors: {
      error: "rgba(239, 197, 202, 1)",
      errorIcon: "rgba(176, 0, 32, 1)",
      info: "#F2F2F2",
      infoIcon: "rgba(0, 0, 0, 0.87)",
    },
    // Alert types
    types: {
      info: "info",
      error: "error",
    },
  },
  /** Csv button types */
  csvButton: {
    color: {
      primary: "primary",
      secondary: "secondary",
    },
  },
  /** Status pills */
  statusChip: {
    color: {
      active: "primary",
      hold: "secondary",
      suspended: "#E88900",
      cancelled: "#F53B57",
      inactive: "#F53B57",
      inbox: "primary",
    },
  },
  defaultLocale: "en-US",
  // Default date format of the application
  defaultDateFormat:"UTC",
  /**
   * Bread crumb component config
   */
  breadcrumbs: {
    types: {
      // Use @type route to render the route with link to the page
      route: "route",
      // Use @type name to render the account name or any string related to that view
      name: "name",
    },
  },
  /**
   * Usage color
   */
  usage: {
    textColor: "rgba(219, 0, 0, 1)",
    backgroundColor: "rgba(219, 0, 0, 0.08)",
  },
  // Common icons config to be used throught out the applicatio
  commonIcons: {
    error: "error",
  },
};

export default Object.freeze(appConfig);
